<script>
import { VERDICTS } from '@/util/content/marketing.js'

// The four verdicts as one continuous scale, laid along the Sigma's own
// gradient: volt blue for a camera capture through ultraviolet for a fully
// generated image. Vertical on phones, horizontal from md up.
export default {
    name: 'VerdictScale',
    computed: {
        verdicts() {
            return VERDICTS
        },
    },
}
</script>

<template>
    <ol class="ps-scale list-unstyled mb-0">
        <li v-for="verdict in verdicts" :key="verdict.value" class="ps-scale__item">
            <span class="ps-scale__band" :class="`ps-swatch-${verdict.tone}`" aria-hidden="true"></span>
            <h3 class="ps-title" :class="`ps-tone-${verdict.tone}`">{{ verdict.name }}</h3>
            <p class="text-muted mb-0">{{ verdict.meaning }}</p>
        </li>
    </ol>
</template>

<style scoped lang="scss">
.ps-scale {
    display: grid;
    grid-template-columns: 1fr;
    gap: 0;
    position: relative;
}

.ps-scale__item {
    position: relative;
    padding: 0 0 2.25rem 1.75rem;
}

.ps-scale__item:last-child {
    padding-bottom: 0;
}

// Phones: a vertical band down the left edge, one tone per verdict.
.ps-scale__band {
    position: absolute;
    left: 0;
    top: 0.35rem;
    bottom: 0;
    width: 0.375rem;
    border-radius: 999px;
}

.ps-scale__item:not(:last-child) .ps-scale__band {
    bottom: 0.5rem;
}

@media (min-width: 768px) {
    .ps-scale {
        grid-template-columns: repeat(4, 1fr);
        gap: 0 0.5rem;
    }

    .ps-scale__item {
        padding: 2.25rem 1.5rem 0 0;
    }

    .ps-scale__band {
        top: 0;
        left: 0;
        right: 0;
        bottom: auto;
        width: auto;
        height: 0.5rem;
    }

    .ps-scale__item:not(:last-child) .ps-scale__band {
        bottom: auto;
    }
}
</style>
